import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const initialState = {
  selectedGroups: {
    diamond: [0],
    lab_grown_diamond: [0],
    gemstone: [0],
    jewelry: [0],
  },
};

const userSelectionsSlice = createSlice({
  name: "selectedGroups",
  initialState: initialState,
  reducers: {
    saveGroup: (state, action) => {
      state.selectedGroups = { ...state.selectedGroups, ...action.payload };
    },
    clearGroup: (state) => {
      state.selectedGroups = initialState.selectedGroups;
    },
  },
});

export const useSearchGroupSlice = () => {
  const selectedGroups = useSelector(
    (state: any) => state.selectedGroups.selectedGroups
  );
  return {
    selectedGroups,
  };
};
export const { saveGroup, clearGroup } = userSelectionsSlice.actions;
export default userSelectionsSlice.reducer;
